import { Component } from 'react';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import { fireOperationalAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { InternalProps } from './types.tsx';

const SEVEN_DAYS_IN_MS = 7 * 24 * 3600 * 1000;

// eslint-disable-next-line jira/react/no-class-components
export class FireEngagementTargetingEvents extends Component<InternalProps> {
	static displayName = 'FireEngagementTargetingEvents';

	componentDidMount(): void {
		const {
			onJswConfluenceBundleCheck,
			onJswJsdBundleCheck,
			createAnalyticsEvent,
			onGetFirstActivationDate,
		} = this.props;
		const isJswConfluenceBundle = onJswConfluenceBundleCheck();
		const isJswJsdBundle = onJswJsdBundleCheck();
		const firstActivationDate = onGetFirstActivationDate();
		const currentTime = Date.now();
		const timeSinceInstanceActivation =
			firstActivationDate !== null ? currentTime - firstActivationDate : null;

		if (
			timeSinceInstanceActivation !== null &&
			timeSinceInstanceActivation > 0 &&
			timeSinceInstanceActivation < SEVEN_DAYS_IN_MS
		) {
			if (isJswConfluenceBundle) {
				fireOperationalAnalytics(createAnalyticsEvent({}), 'appswitcherSpotlight targeting');
			}

			if (isJswJsdBundle) {
				fireOperationalAnalytics(createAnalyticsEvent({}), 'appswitcherjsdspotlight targeting');
			}
		}
	}

	render() {
		return null;
	}
}

export default withAnalyticsEvents()(FireEngagementTargetingEvents);
